import { FileDownload } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { InvoicePdfDocument, type InvoicePdfData } from './InvoicePdfDocument';

type InvoiceDownloadButtonProps = {
  data: InvoicePdfData | null;
};

export const InvoiceDownloadButton = ({ data }: InvoiceDownloadButtonProps) => {
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  return (
    <PDFDownloadLink document={<InvoicePdfDocument data={data} />} fileName={`upominej-faktura-${data.number}.pdf`}>
      {({ loading }) => (
        <LoadingButton startIcon={<FileDownload />} variant="outlined" loading={loading}>
          {t('invoice.download')}
        </LoadingButton>
      )}
    </PDFDownloadLink>
  );
};
